export default __webpack_public_path__ + "static/media/partner_logo_fleks.610c28a3.svg";